/**
 * İmzacının API isteklerinin politikası (DEV-3902, DEV-3904).
 *
 *  - Arka plan istekleri SESSİZDİR: bot her 5 sn'de bir next-task, her dakika görev listesi,
 *    her devirde lisans sorgusu atar; sunucu/ağ bozukken bunların her başarısızlığı bir toast
 *    olursa ekran toast yağmuruna döner (hata bölümü başına tek bildirimi bot döngüsü verir).
 *  - 423 cevapları imza/lisans kimlik denetimidir (Laravel IMZACI_TCKN_DENETIMI): toast değil,
 *    engelleyici uyarı + bot duraklatma ile karşılanır.
 *  - X-Imzaci-* başlıkları yalnız imzacı kabuğuna giden /api/ isteklerine eklenir.
 *
 * Saf tutuldu (store/DOM bağımlılığı yok) ki birim testten geçebilsin.
 */

export interface IstekBenzeri {
    url?: string;
    baseURL?: string;
    method?: string;
    sessiz?: boolean;
}

/** URL'nin yalnız yol bölümü ('/api/v1/task'); sorgu ve parça atılır. Ayrıştırılamıyorsa ''. */
function yolu(url: string): string {
    if (/^[a-z][a-z0-9+.-]*:\/\//i.test(url)) {
        try {
            return new URL(url).pathname;
        } catch (e) {
            return '';
        }
    }
    const yol = url.split('#')[0].split('?')[0];
    return yol.charAt(0) === '/' ? yol : '/' + yol;
}

function kokOrigin(url: string): string | null {
    try {
        return new URL(url).origin;
    } catch (e) {
        return null;
    }
}

function sondakiEgikCizgiyiAt(yol: string): string {
    return yol.length > 1 ? yol.replace(/\/+$/, '') : yol;
}

/**
 * Hata toast'ı atılmayacak arka plan isteği mi: `sessiz:true`, ya da yolu
 * /api/v1/next-task, /api/v1/imzaci/kimlik ya da (GET) TAM OLARAK /api/v1/task (liste).
 * /api/v1/task/12/child-tasks gibi görev uçları sessiz DEĞİL (kullanıcı eylemi).
 */
export function istekSessizMi(config: IstekBenzeri | null | undefined): boolean {
    if (!config) {
        return false;
    }
    if (config.sessiz === true) {
        return true;
    }
    const yol = sondakiEgikCizgiyiAt(yolu(String(config.url ?? '')));
    if (yol === '/api/v1/next-task' || yol === '/api/v1/imzaci/kimlik') {
        return true;
    }
    const yontem = String(config.method ?? 'get').toLowerCase();
    return yol === '/api/v1/task' && yontem === 'get';
}

/**
 * İstek imzacı kabuğunun /api/ yoluna mı gidiyor (X-Imzaci-* başlıkları için). Göreli URL
 * baseURL'e eklenir; mutlak URL ise baseURL ile AYNI origin olmalı: /openBrowser gibi diğer
 * uçlara ve başka sunuculara özel başlık eklenmez.
 */
export function apiYoluMu(config: IstekBenzeri | null | undefined): boolean {
    if (!config) {
        return false;
    }
    const url = String(config.url ?? '');
    const yol = yolu(url);
    if (yol.indexOf('/api/') !== 0) {
        return false;
    }
    if (/^[a-z][a-z0-9+.-]*:\/\//i.test(url)) {
        const hedef = kokOrigin(url);
        const taban = config.baseURL ? kokOrigin(config.baseURL) : null;
        return hedef !== null && taban !== null && hedef === taban;
    }
    return true;
}

/**
 * 423 cevabının nedeni: Laravel gövdesindeki `type` 'imza_lisans_uyusmuyor' → 'lisans',
 * 'imza_lisans_tckn_eksik' → 'lisans-tckn'. Başka durum/tür null (normal 4xx gibi işlenir).
 */
export function lisansHatasiTuru(error: unknown): 'lisans' | 'lisans-tckn' | null {
    const cevap = (error as {response?: {status?: unknown, data?: {type?: unknown}}} | null | undefined)?.response;
    if (!cevap || cevap.status !== 423) {
        return null;
    }
    const tur = cevap.data ? cevap.data.type : undefined;
    if (tur === 'imza_lisans_uyusmuyor') return 'lisans';
    if (tur === 'imza_lisans_tckn_eksik') return 'lisans-tckn';
    return null;
}
